import { useQuery } from '@tanstack/react-query';
import { api } from './api-client.js';

export interface PresenceUser {
  accountId: string;
  pseudo: string;
  avatarUrl: string | null;
}

export interface PresenceListResponse {
  users: PresenceUser[];
}

export const PRESENCE_USERS_QUERY_KEY = ['presence', 'users'] as const;

export function usePresenceUsers(enabled: boolean) {
  return useQuery({
    queryKey: PRESENCE_USERS_QUERY_KEY,
    queryFn: () => api.get<PresenceListResponse>('/api/presence'),
    enabled,
    staleTime: 5_000,
  });
}
